webpackJsonp([183328146348521],{

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _GriegNightCircle = __webpack_require__(35);
	
	var _GriegNightCircle2 = _interopRequireDefault(_GriegNightCircle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageNotFound = function (_React$Component) {
	  _inherits(PageNotFound, _React$Component);
	
	  function PageNotFound() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PageNotFound);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.render = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'base404 flex center column basePad', style: { height: '100%', width: '100%', backgroundColor: 'white' } },
	        _react2.default.createElement('img', { src: _GriegNightCircle2.default, alt: 'Grieg minutt for minutt logo', style: { height: "200px", marginBottom: "4rem" } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex center column' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Innholdet her er fortsatt hemmelig.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Du m\xE5 nok vente i spenning.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'F\xF8lg med og hold deg oppdatert.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Vi publiserer litt etter litt.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'button' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/' },
	            'Returner hjem'
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return PageNotFound;
	}(_react2.default.Component);
	
	exports.default = PageNotFound;
	module.exports = exports['default'];

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/GriegNightCircle250.4a4d1d3b.png";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-jsx-b6181a6c4e647161678a.js